import {
  Box,
  Button,
  Grid,
  Popover,
  TextField,
  ToggleButton,
} from "@mui/material";
import { Editor } from "@tiptap/react";
import { memo, useRef, useState } from "react";
import InsertLinkRoundedIcon from "@mui/icons-material/InsertLinkRounded";

export const InsertLinkButton = memo(
  ({ editor }: { editor: Editor | null }) => {
    const [open, setOpen] = useState(false);
    const [text, setText] = useState("");
    const [link, setLink] = useState("");
    const [isValidLink, setIsValidLink] = useState(false);

    const ref = useRef(null);

    const handleClose = () => {
      setOpen(false);
      setText("");
      setLink("");
      setIsValidLink(false);
    };

    const handleClick = () => {
      setOpen(true);
    };

    const validateLink = (url: string) => {
      const urlPattern = /^(https?:\/\/)?([\w.-]+)\.([a-z]{2,})(\/\S*)?$/i;
      return urlPattern.test(url);
    };

    const handleLinkChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value;
      setLink(value);
      setIsValidLink(validateLink(value));
    };

    const handleInsert = () => {
      if (editor && isValidLink) {
        editor
          .chain()
          .focus()
          .insertContent(
            `<a href="${link}" target="_blank">${text ? text : link}</a>`
          )
          .run();

        editor
          .chain()
          .focus()
          .setTextSelection(editor.state.selection.to)
          .unsetMark("link")
          .insertContent(" ")
          .run();

        handleClose();
      }
    };

    if (!editor) {
      return null;
    }

    return (
      <>
        <Popover
          open={open}
          anchorEl={ref.current}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
        >
          <Box sx={{ p: 2, width: 300 }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  placeholder="Texto"
                  size="small"
                  fullWidth
                  value={text}
                  onChange={(e) => setText(e.target.value)}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  placeholder="Digite ou cole um link"
                  size="small"
                  fullWidth
                  value={link}
                  onChange={handleLinkChange}
                  error={!!link && !isValidLink}
                  helperText={
                    !!link && !isValidLink ? "Insira um link válido" : ""
                  }
                />
              </Grid>
              <Grid
                item
                xs={12}
                display="flex"
                justifyContent="flex-end"
                gap={2}
              >
                <Button variant="outlined" onClick={handleClose}>
                  Cancelar
                </Button>
                <Button
                  variant="contained"
                  onClick={handleInsert}
                  disabled={!isValidLink}
                >
                  Inserir
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Popover>
        <ToggleButton
          value="link"
          selected={editor.isActive("link")}
          ref={ref}
          onClick={handleClick}
        >
          <InsertLinkRoundedIcon />
        </ToggleButton>
      </>
    );
  }
);
